import styled from 'styled-components';

export const $BannerContent = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 32px 36px;
  overflow: hidden;
  flex-shrink: 0;

  .new-service {
    color: #2ed59d;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    align-self: flex-start;
  }
`;

export const $BannerTitle = styled.h1`
  font-size: 24px;
  font-weight: 400;
  margin: 0;
  line-height: 1.1;
  color: white;
  letter-spacing: 0.5px;
`;

export const $BannerFeatures = styled.ul`
  list-style: none;
  padding: 0;
  margin: 8px 0 12px 0;
  display: flex;
  flex-direction: column;
  gap: 6px;

  li {
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.4;

    &:before {
      content: '•';
      margin-right: 8px;
      font-size: 20px;
      font-weight: bold;
      opacity: 0.2;
    }
  }
`;

export const $ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const baseButtonStyles = `
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  
  justify-content: center;
  gap: 8px;
  flex: 1;
  white-space: nowrap;
`;

export const $TryNowButton = styled.button`
  ${baseButtonStyles};
  background: #ffffffff;
  color: #1a1a1e;

  &:hover {
    background: #ffffffee;
  }

  &.disabled {
    opacity: 0.6;
    cursor: default;

    &:hover {
      background: #ffffffff;
    }
  }
`;

export const $ReadDocumentationButton = styled.button`
  ${baseButtonStyles};
  background: transparent;
  color: #dadae2;
  border: 1px solid #dadae2;
  padding: 6px 24px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.6);
  }
`;

export const $DemoContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 0;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 1;
  transition: all 0.2s ease;
  overflow: hidden;

  img {
    width: 110%;
    object-fit: contain;
    opacity: 1;
  }

  @media (max-height: 720px) {
    flex: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
  }
`;
